import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'suvo-bi-skeleton-map',
  templateUrl: './skeleton-map.component.html',
  styleUrls: ['./skeleton-map.component.scss'],
})
export class SkeletonMapComponent {}
